module.exports = __webpack_public_path__ + "assets/669681afdfa41ba6cc3777cb968a9cd6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_05.mp3
 ** module id = 45
 ** module chunks = 0
 **/